import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subject } from 'rxjs';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-configurazione-limite-sconti',
	templateUrl: './configurazione-limite-sconti.component.html',
	styleUrls: ['./configurazione-limite-sconti.component.scss'],
})
export class ConfigurazioneLimiteScontiComponent implements OnInit, OnDestroy {
	constructor(private api: ApiService) {}

	agenti: any[] = [];
	utenti: any[] = [];
	dtTrigger: Subject<any> = new Subject<any>();

	dtSettings: any = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: false },
			{ searchable: false, targets: 1, orderable: false },
			{ searchable: false, targets: 2, orderable: false },
		],
		order: [],
		dom: 'Bfrtip',
		buttons: [
			{
				extend: 'excel',
				exportOptions: {
					columns: [0, 1, 5, 6],
				},
			},
		],
	};

	ngOnInit() {
		this.api.getUtenti().subscribe((res) => {
			this.utenti = res;
			this.utenti = this.utenti
				.map((user) => ({ ...user, idAgente: user.agente ? user.agente.id : null }))
				.filter((user) => user.ruolo === 'AGENTE_ESTERNO' || user.ruolo === 'AGENTE_INTERNO' || user.ruolo === 'CLIENTE')
				.map((user) => ({
					...user,
					ordinamento:
						user.ruolo === 'AGENTE_ESTERNO' || user.ruolo === 'AGENTE_INTERNO'
							? user.id * 1000
							: user.agente
								? user.agente.id * 1000 + 1
								: Number.MAX_SAFE_INTEGER,
				}))
				.sort((user1, user2) => user1.ordinamento - user2.ordinamento);
			console.log(this.utenti);
			this.dtTrigger.next();
		});
		this.api.getAgenti().subscribe((agenti) => (this.agenti = agenti));
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	save(utente) {
		console.log(utente);
		delete utente.password;
		this.api.saveUtente(utente).subscribe(() => (utente.feEdit = false));
	}
}
